module.exports = __webpack_public_path__ + "media/images/flags/1x1/btn-b0115347b3e0cce7e7363f22d0862178.svg";